import styled from 'styled-components';

export const InfoSec = styled.div`
  color: #fff;
  padding: 80px 0;
  background: ${({ lightBg }) => (lightBg ? 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)' : 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)')};
  border-bottom: 1px solid ${({ lightBg }) => (lightBg ? 'rgba(0,0,0,0.04)' : 'rgba(255,255,255,0.02)')};
`;

export const InfoRow = styled.div`
  display: flex;
  margin: 0 -15px -15px -15px;
  flex-wrap: wrap;
  align-items: center;
  flex-direction: ${({ imgStart }) => (imgStart ? 'row-reverse' : 'row')};
`;

export const InfoColumn = styled.div`
  margin-bottom: 15px;
  padding-right: 15px;
  padding-left: 15px;
  flex: 1;
  max-width: 50%;
  flex-basis: 50%;

  @media screen and (max-width: 768px) {
    max-width: 100%;
    flex-basis: 100%;
    display: flex;
    justify-content: center;
  }
`;

export const TextWrapper = styled.div`
  max-width: 540px;
  padding-top: 0;

  @media screen and (max-width: 768px) {
    padding-bottom: 30px;
  }
`;

export const ImgWrapper = styled.div`
  max-width: 555px;
  display: flex;
  justify-content: ${({ start }) => (start ? 'flex-start' : 'flex-end')};
`;

export const TopLine = styled.div`
  color: ${({ lightTopLine }) => (lightTopLine ? '#818cf8' : '#4f46e5')};
  font-size: 0.85rem;
  line-height: 16px;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  margin-bottom: 12px;
  font-family: 'Inter', sans-serif;
`;

export const TopLine2 = styled.div`
  margin-bottom: 16px;
  font-size: 2.2rem;
  line-height: 1.2;
  font-weight: 800;
  font-family: 'Outfit', sans-serif;
  color: #fff;
  background: linear-gradient(135deg, #ffffff 30%, #a5b4fc 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export const Img = styled.img`
  padding-right: 0;
  border: 0;
  max-width: 100%;
  vertical-align: middle;
  display: inline-block;
  max-height: 450px;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.02);
  }
`;

export const Heading = styled.h2`
  margin-bottom: 20px;
  font-size: 2.5rem;
  line-height: 1.2;
  font-weight: 800;
  font-family: 'Outfit', sans-serif;
  color: ${({ lightText }) => (lightText ? '#ffffff' : '#0f172a')};

  @media screen and (max-width: 768px) {
    font-size: 1.8rem;
  }
`;

export const Subtitle = styled.p`
  max-width: 480px;
  margin-bottom: 30px;
  font-size: 1.05rem;
  line-height: 1.7;
  font-family: 'Inter', sans-serif;
  color: ${({ lightTextDesc }) => (lightTextDesc ? '#cbd5e1' : '#475569')};
  text-align: left;
`;

export const Subtitle1 = styled.p`
  max-width: 480px;
  margin-bottom: 30px;
  font-size: 1.05rem;
  line-height: 1.7;
  font-family: 'Inter', sans-serif;
  color: ${({ lightTextDesc }) => (lightTextDesc ? '#cbd5e1' : '#475569')};
  text-align: left;
`;




